export const templates = [
  { id: "classic", name: "기본형", navigation: "persistent", detail: "dialog" },
  { id: "notion", name: "Notion", navigation: "collapsible", detail: "sheet" },
  { id: "simple", name: "Simple", navigation: "top", detail: "dialog" },
  {
    id: "simple-month",
    name: "Simple 월간",
    navigation: "top",
    detail: "dialog",
  },
] as const;
export type TemplateId = (typeof templates)[number]["id"];
export const isSimpleTemplate = (template: TemplateId) =>
  template === "simple" || template === "simple-month";
export const accents = [
  { id: "preset", name: "프리셋", color: "var(--accent)" },
  { id: "blue", name: "블루", color: "#315de7" },
  { id: "green", name: "그린", color: "#176b50" },
  { id: "rose", name: "로즈", color: "#ae3155" },
  { id: "graphite", name: "차콜", color: "#454545" },
] as const;
export type Accent = (typeof accents)[number]["id"];
export type Corners = "preset" | "square" | "soft" | "round";
export type FontChoice = "preset" | "pretendard" | "suit" | "system";
